export const compatibleLayouts = {
  string: ['text', 'checkbox', 'select', 'radio', 'radioButtons', 'hidden'],
  integer: ['number', 'money', 'slider', 'duration', 'checkbox', 'select', 'radio', 'radioButtons', 'hidden'],
  boolean: ['checkbox', 'select', 'radio', 'radioButtons', 'hidden'] // radio

};